import React from 'react';
const VITE_STATIC_URL = import.meta.env.VITE_STATIC_URL || '';
const ActionCard = ({ title, desc, imageUrl, onClick }) => {
    return (
        <div className="h-72 w-56 md:h-80 flex flex-col items-center content-center justify-between 
        bg-primary/90 border border-primary-foreground p-6 rounded-2xl md:w-64 text-center" onClick={onClick}>
            {/* Placeholder for icon - you can replace this */}
            <div className="mx-auto">
                <img
                    src={`${VITE_STATIC_URL}${imageUrl}`}
                    alt={title}
                    className="w-24 h-24 object-cover"
                />
            </div>

            <h2 className="text-foreground text-l md:text-2xl font-semibold mb-3">
                {title}
            </h2>
            <p className="text-foreground text-xs md:text-sm md:leading-relaxed">
                {desc}
            </p>
        </div>
    );
};

export default ActionCard;
